import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellUserRoles: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TableCellUserRoles' };

import { computed } from 'vue';
import { sortBy } from 'lodash';

import type { User } from '@models';
import { useStore } from '@store';
import { RoleId } from '@values/roles';
/**
 * `TableCellUserRoles` component properties.
 */
export interface Props {
  /** ... */
  item: User;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  /** ... */
  item: User;
};

const store = useStore();



const roleId = computed(() => {
  return store.state.me.selectedRole?.roleId;
});

const isLasAdmin = computed(() => {
  return roleId.value === RoleId.LasAdmin;
});

const organizationId = computed(() => {
  return store.state.me.selectedRole?.organization?.id;
});

/** ... */
const roles = computed(() => {
  let items = props.item.roles ?? [];

  if (!isLasAdmin.value && organizationId.value) {
    items = items.filter(
      ({ organization }) => organization?.id === organizationId.value,
    );
  }

  return sortBy(items, ['id']).reverse();
});

return { __sfc: true,store, props, roleId, isLasAdmin, organizationId, roles }
}

})